import {
    Box,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { useState, useEffect } from "react";
import { ArrowLeft, CircleCheck, Circle, } from "lucide-react";
import { useTranslation } from "react-i18next";



const CheckList = () => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery("(max-width:1150px)");
    const [selectedAutoOptions, setSelectedAutoOptions] = useState([]);

    const AUTOMATIC_OPTIONS = [
        { key: "addOnServicesSelected", titleKey: "addOnServicesSelected" },
        { key: "specialCareRequirements", titleKey: "specialCareRequirements" },
        { key: "petStayingTogether", titleKey: "petStayingTogether" },
        { key: "LateCheckInCheckOut", titleKey: "LateCheckInCheckOut" },
        { key: "petDetailsNotMeetRoomRequirements", titleKey: "petDetailsNotMeetRoomRequirements" },
    ];

    const toggleAutoOption = (key) => {
        setSelectedAutoOptions((prev) => {
            if (prev.includes(key)) {
                return prev.filter((k) => k !== key);
            } else {
                return [...prev, key];
            }
        });
    };

    return (
        <Box sx={{ position: "fixed", bottom: 10, right: 20, width: "350px", backgroundColor: "white", zIndex: 100, boxShadow: "0px -2px 4px rgba(0, 0, 0, 0.1)", }}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 1, padding: 2, }}>
                <Typography variant="h6">
                    {t('CheckList')}
                </Typography>
                {AUTOMATIC_OPTIONS.map((autoOption) => {
                    const isAutoSelected = selectedAutoOptions.includes(autoOption.key);
                    return (
                        <Box
                            key={autoOption.key}
                            onClick={() => toggleAutoOption(autoOption.key)}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                cursor: "pointer",
                                padding: "8px",
                                borderRadius: "6px",
                                transition: "background-color 0.2s",
                                "&:hover": { backgroundColor: "#F5F5F5" },
                            }}
                        >
                            {isAutoSelected ? (
                                <CircleCheck size={16} color="#31BACD" style={{ flexShrink: 0 }} />
                            ) : (
                                <Circle size={16} color="#999" style={{ flexShrink: 0 }} />
                            )}
                            <Typography sx={{ fontSize: isMobile ? "12px" : "13px", color: "#666" }}>
                                {t(autoOption.titleKey)}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default CheckList;
